import { useState } from "react";
import { AccumulativeDispatchFilter } from "../fragments.dispatches/AccumulativeDispatchFilter";
import { AccumulativeDispatchList } from "../fragments.dispatches/AccumulativeDispatchList";

export function AccumulativeDispatchPage() {
    const [orders, setOrders]               = useState([]);
    const [vehicles, setVehicles]           = useState([]);
    const [users, setUsers]                 = useState([]);
    const [operationStatus]                 = useState([
        { id: "02", name: "Comprobantes Generados" },
        { id: "01", name: "Cotizaciones" },
    ]);

    return (
        <>
            {/* Page header */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Ventas acumuladas por producto
                        </h1>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">Distribuciones</li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">/</li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">Listado</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4 space-y-4">
                    <AccumulativeDispatchFilter
                        setOrders={setOrders}
                        vehicles={vehicles}
                        setVehicles={setVehicles}
                        users={users}
                        setUsers={setUsers}
                        operationStatus={operationStatus}
                        ordersCount={orders.length}
                    />
                    <AccumulativeDispatchList orders={orders} />
                </div>
            </section>
        </>
    );
}
